import { render, staticRenderFns } from "./modal-tos-page-1.vue?vue&type=template&id=3d9e2344"
import script from "./modal-tos-page-1.vue?vue&type=script&lang=js"
export * from "./modal-tos-page-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports